import React, { useState } from "react";
import { HiMiniArrowUpRight } from "react-icons/hi2";
import AButton from "../../../common/form-fields-mui/AButton";
import {
  formattedPrice,
  getErrorMessage,
  getSelectedItemList,
  validateSequencing,
  isLumpSumItemSelected,
  isSeatBookingEnabled,
  isChequeEnabled,
  isEnachEnabled,
  isUptoIstallmentEnabled,
} from "../utils";
import { useGetCollectPaymentContext } from "../context";
import PartialPaymentPopup from "../partialPayment";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";

const SelectChargesFooter = ({}) => {
  const {
    selectedChargesAmount,
    setCurrentPageState,
    setCurrentStep,
    partialAddAmount,
    studentBasicDetails,
    selectedCharges,
  } = useGetCollectPaymentContext();
  const selectedItemList = getSelectedItemList(selectedCharges);
  const [isMakePartialPayment, setIsMakePartialPayment] = useState(false);

  const partialPaymentBtnHandler = () => {
    const {
      lumpSumType,
      upFrontAmount,
      popUpMessageList = [],
    } = studentBasicDetails || {};
    if (isChequeEnabled(studentBasicDetails))
        return failureToast("Partial payment is not allowed!");
    if (lumpSumType || upFrontAmount) {
      if (studentBasicDetails?.upFrontAmount)
        return failureToast(getErrorMessage(popUpMessageList));
      if ((lumpSumType || isSeatBookingEnabled(studentBasicDetails)) && isLumpSumItemSelected(selectedItemList))
        return failureToast("Partial payment is not allowed!");
    }
    if(isUptoIstallmentEnabled(studentBasicDetails)){
      return failureToast("Partial payment is not allowed!");
    }
    if (selectedChargesAmount > 0) setIsMakePartialPayment(true);
  };

  const disabledPaymentButtonHandler = () => {
    if (selectedItemList.length > 0) return false;
    return !selectedChargesAmount;
  };

  return (
    <div
      className={`select-charges-footer ${
        selectedChargesAmount > 0 || selectedItemList.length > 0
          ? "charges-selected"
          : ""
      }`}
    >
      <div className="d-flex flex-column">
        <div className="heading-3">
          Total Amount : {formattedPrice(selectedChargesAmount)}
        </div>
        <div className="heading-3 dotted-border">
          Make Partial Payment
          <HiMiniArrowUpRight
            onClick={partialPaymentBtnHandler}
            className="cursor"
            size={24}
          />
        </div>
      </div>

      <div className="d-flex align-items-center ml-auto">
        <div>
          <div className="heading-3 mr-4 d-flex">
            Amount to be paid:
            <div className="ml-1">
              {(partialAddAmount && formattedPrice(partialAddAmount)) ||
                formattedPrice(selectedChargesAmount)}
            </div>
          </div>
        </div>
        <AButton
          variant="primary_filled"
          onClick={() => {
            validateSequencing(
              studentBasicDetails,
              selectedCharges,
              partialAddAmount || selectedChargesAmount
            );
            setCurrentPageState("SELECT_PAYMENT_MODE");
            setCurrentStep((prev) => prev + 1);
          }}
          disabled={disabledPaymentButtonHandler()}
        >
          Select payment mode
        </AButton>
      </div>
      <PartialPaymentPopup
        open={isMakePartialPayment}
        setOpen={setIsMakePartialPayment}
      />
    </div>
  );
};

export default SelectChargesFooter;
